
let config = {
  toolbar1: 'undo redo previewFunction | fontselect fontsizeselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | image downloadAsPic | clearAll',
  toolbar2: 'insertBackground | deleteBackground ',
  font_formats: "Arial=arial, sans-serif; Georgia=georgia, palatino; Times New Roman=times new roman,times; Verdana=verdana, geneva",
  fontsize_formats: "10pt 12pt 14pt 18pt 24pt 36pt 48pt",
  past_data_images: true, //allow to insert images
  resize: false, //removes the option to resize editor
  elementpath: false, //disable the display of the elementpath left bottom
  width: 1282,
  height: 857,
  plugins: 'image lists', //allow to insert images
  images_dataimg_filter: (img) => { // disable blob conversion
    return img.hasAttribute('internal-blob');
  }
};

export default config;